/**
 * LoadingSkeleton - Skeleton loading placeholders
 * Shows shimmer effect while lazy components load
 */

export interface SkeletonProps {
  width?: string | number;
  height?: string | number;
  borderRadius?: string;
  className?: string;
}

export function Skeleton({ width = '100%', height = '20px', borderRadius = '8px', className = '' }: SkeletonProps) {
  return (
    <div
      className={className}
      style={{
        width,
        height,
        borderRadius,
        background: 'linear-gradient(90deg, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0.1) 50%, rgba(255,255,255,0.05) 100%)',
        backgroundSize: '200% 100%',
        animation: 'shimmer 1.5s infinite',
      }}
    >
      <style>
        {`
          @keyframes shimmer {
            0% {
              background-position: -200% 0;
            }
            100% {
              background-position: 200% 0;
            }
          }
        `}
      </style>
    </div>
  );
}

export function ChartSkeleton() {
  return (
    <div style={{ padding: '20px' }}>
      <Skeleton width="40%" height="24px" style={{ marginBottom: '16px' }} />
      <Skeleton width="100%" height="300px" />
    </div>
  );
}

export function StatCardSkeleton() {
  return (
    <div className="glass-card" style={{ padding: '20px' }}>
      <Skeleton width="60%" height="16px" style={{ marginBottom: '12px' }} />
      <Skeleton width="40%" height="32px" style={{ marginBottom: '8px' }} />
      <Skeleton width="50%" height="14px" />
    </div>
  );
}

export function HeatmapSkeleton() {
  return (
    <div style={{ padding: '20px' }}>
      <Skeleton width="30%" height="20px" style={{ marginBottom: '20px' }} />
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(52, 1fr)',
        gap: '4px'
      }}>
        {Array.from({ length: 364 }).map((_, i) => (
          <Skeleton key={i} width="100%" height="12px" borderRadius="2px" />
        ))}
      </div>
    </div>
  );
}

export function StatsGridSkeleton() {
  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
      gap: '16px',
      marginBottom: '30px'
    }}>
      {Array.from({ length: 8 }).map((_, i) => (
        <StatCardSkeleton key={i} />
      ))}
    </div>
  );
}

export function CourseRowSkeleton() {
  return (
    <div style={{ marginBottom: '40px' }}>
      <Skeleton width="30%" height="24px" style={{ marginBottom: '20px' }} />
      <div style={{
        display: 'flex',
        gap: '16px',
        overflowX: 'hidden'
      }}>
        {Array.from({ length: 5 }).map((_, i) => (
          <Skeleton key={i} width="280px" height="200px" borderRadius="12px" />
        ))}
      </div>
    </div>
  );
}
